import * as React from 'react';
import { emptyAttendee, IAttendee } from '../../../../Models/Attendees/IAttendee';
import { AttendeeDetailForm } from '../../../Attendees/AttendeeDetail/AttendeeDetailForm'
import * as Services from '../../../../Services/Services';
import { useBoolean } from '@fluentui/react-hooks';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { FontIcon, Text, mergeStyles, MessageBarType, Panel, PanelType, Stack, useTheme, ProgressIndicator, PrimaryButton, DefaultButton, MessageBar } from '@fluentui/react';
import { IAdminApi } from '../../../../Services/API/Admin/IAdminApi';
import { AttendeeDetailView } from '../../../Attendees/AttendeeDetail/AttendeeDetailView';


interface IAttendeePropertiesAdminProps {
    item: IAttendee;
    isOpen: boolean;
    close: () => void;
    refresh: (id: number) => void;
}


export const AttendeePropertiesAdmin: React.FunctionComponent<IAttendeePropertiesAdminProps> = (props) => {

    const [isLoading, setIsLoading] = useBoolean(false);
    const [editItem, setEditItem] = React.useState<IAttendee>(emptyAttendee(""));
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isFormValid, setIsFormValid] = React.useState(false);

  


    const theme = useTheme();
    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });

    React.useEffect(() => {
        setEditItem(props.item);
    }, [props.item]);

    const propertyChanged = (key: string, value: any) => {
        setEditItem({ ...editItem, [key]: value });
    }
 
    const updateAttendee = async (event: IAttendee) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const adminApi  = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
        const result = await adminApi.updateAttendee(event);

        if (result.isSuccess) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            await props.refresh(editItem.id);
            props.close();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const createAttendee = async (event: IAttendee) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const adminApi = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
        const result = await adminApi.addAttendee(event);

        if (result.isSuccess && result.data) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            await props.refresh(result.data);
            props.close();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }


    return (
        <AttendeeDetailView
            item={editItem}
            isOpen={props.isOpen}
            isLoading={isLoading}
            propertyChanged={propertyChanged}
            close={props.close}
            statusMessage={statusMessage}
            updateAttendee={updateAttendee}
            createAttendee={createAttendee} />
    )
 
}
